import type { EditorPlugin, EnhanceEditorState } from '../../types';
import { HISTORY_PLUGIN_ID } from './types';
import type { HistoryPluginOptions, HistoryPluginPropertyOptions } from './types';
import { withHistory } from 'slate-history';
import { onKeyDownHistory } from './onKeyDownHistory';

export const HistoryPlugin = ({
  pluginName = 'History',
}: HistoryPluginOptions = {}): EditorPlugin => {
  const options: HistoryPluginPropertyOptions = {
    pluginID: HISTORY_PLUGIN_ID,
    pluginName,
  };

  return {
    pluginID: options.pluginID,
    enhanceEditorState: withHistoryIdempotently,
    onKeyDown: onKeyDownHistory(options),
  };
};

const withHistoryIdempotently: EnhanceEditorState = (editor) => {
  // Ensure we only apply withHistory once, idempotently
  if ('history' in editor && editor.history) {
    return editor;
  }
  return withHistory(editor);
};
